import React from 'react'

import styles from './Imageslider.module.css'

export type ImageSliderCardEndorsementProps = {
  itemKey: string
  stars: number
  description: string
  name: string
  position: string
}

export const PhnxImageSliderCardEndorsement: React.FC<ImageSliderCardEndorsementProps> = ({
  itemKey,
  stars,
  description,
  name,
  position,
}) => {
  return (
    <div className={styles.imageslidercardEndorsement} key={itemKey}>
      <div className={styles.endoresementContent}>
        <div className={styles.endoresementStars}>
          {[...Array(Number(stars))].map((_, i) => (
            <svg key={i} className="w-6 h-6 text-[#D43D27]" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          ))}
        </div>
        <div className={styles.endoresementDescription}>
          <p className="line-clamp-9 p-0">{description}</p>
        </div>
        <div className={styles.endoresementPerson}>
          <span className={styles.endoresementName}>{name}</span>
          {position}
        </div>
      </div>
    </div>
  )
}
